module.exports = __webpack_public_path__ + "static/media/instluminarias.135944e8.webp";